// Catálogo de permisos. Módulo sin dependencias a propósito:
// auth.js lo evalúa al importarse, y tenerlo aquí evita el ciclo
// helpers.js -> apiRequest.js -> auth.js -> helpers.js, que dejaba
// 'permisions' sin inicializar según el orden de evaluación del bundler.

export const permisions = {
	salud: 'Salud',
	visitaSalud: 'visitas-salud',
	pacientes: 'pacientes-salud',
	inventarioSalud: 'inventario-salud',

	verCarta: 'ver-carta',
	verCartas: 'ver-cartas',
	verPlantillas: 'ver-plantillas',

	abrirTarjeta: 'abrir-tarjetas',
	editarInventario: 'editar-inventario',
	crearProductos: 'crear-productos',
	editarProductos: 'editar-productos',
	eliminarProductos: 'eliminar-productos',
	movimientoMasivos: 'movimiento-masivos',
	exportarCatalogo: 'exportar-catalogo',
	editarSucursales: 'editar-sucursales',
	editarUsuarios: 'editar-usuarios',
	verAcademico: 'ver-academico',
	verCompras: 'ver-compras',
	verComprasRecurrentes: 'ver-compras-recurrentes',
	verComprobantes: 'ver-comprobantes',
	verConfiguracion: 'ver-configuracion',
	verConsultas: 'ver-consultas',
	verContabilidad: 'ver-contabilidad',
	verCheque: 'ver-cheque',
	verCuentaContable: 'ver-cuenta-contable',
	verEntradasDiarios: 'ver-entrada-diarios',
	verReporteContables: 'ver-reporte-contable',

	verContactos: 'ver-contactos',
	verContratos: 'ver-contratos',
	verCotizaciones: 'ver-cotizaciones',
	verCuentas: 'ver-cuentas',
	verCuentasPorCobrar: 'ver-cuentas-por-cobrar',
	verCuentasPorPagar: 'ver-cuentas-por-pagar',
	verDashboard: 'ver-dashboard',
	dashboardVendedores: 'dashboard-vendedores',
	verDescuentos: 'ver-descuentos',
	verEmpleados: 'ver-empleados',
	verEstudiantes: 'ver-estudiantes',
	verEvaluaciones: 'ver-evaluaciones',
	verFacturacionAcademica: 'ver-facturacion-academica',
	verFacturas: 'ver-facturas',
	verFacturasRecurrentes: 'ver-facturas-recurrentes',
	verDespachoFacturas: 'ver-despacho-facturas',
	verGastos: 'ver-gastos',
	crearGastos: 'crear-gastos',
	editarGastos: 'editar-gastos',
	verGastosGenerales: 'ver-gastos-generales',
	verGastosInternos: 'ver-gastos-internos',
	verGiGrupos: 'ver-gi-grupos',
	verGiPrestamos: 'ver-gi-prestamos',
	verGiServidores: 'ver-gi-servidores',
	verGrupoTiposEmpleados: 'ver-grupo-tipos-empleados',
	verIncentivos: 'ver-incentivos',
	verIngresos: 'ver-ingresos',
	verEgresos: 'ver-egresos',
	verInscripcion: 'ver-inscripcion',
	verInventario: 'ver-inventario',
	verAlmacenes: 'ver-almacenes',
	verUbicaciones: 'ver-ubicaciones',
	verActivoFijo: 'ver-activo-fijo',
	crearActivoFijo: 'crear-activo-fijo',
	editarActivoFijo: 'editar-activo-fijo',
	verNomina: 'ver-nomina',
	verNotasCredito: 'ver-notas-credito',
	verNotasDebito: 'ver-notas-debito',
	verOrdenesCompra: 'ver-ordenes-compra',
	verPedidos: 'ver-pedidos',
	verPadrestutores: 'ver-padres-tutores',
	verProductos: 'ver-productos',
	verCategorias: 'ver-categorias',
	verProgramacion: 'ver-programacion',
	verRecibosIngreso: 'ver-recibos-ingreso',
	verReclamaciones: 'ver-reclamaciones',
	verCuadreCaja: 'ver-cuadre-caja',
	verReportes: 'ver-reportes',
	verRutas: 'ver-rutas',
	verServicios: 'ver-servicios',
	verSolicitudes: 'ver-solicitudes',
	verTipos: 'ver-tipos',
	verVehiculos: 'ver-vehiculos',
	verPlantillasImpresion: 'ver-plantillas-impresion',
	verCocurriculares: 'ver-cocurriculares',
	verCobros: 'ver-cobros',
	verInscripcionCocurriculares: 'ver-inscripcion-cocurriculares',
	verAusencias: 'ver-ausencias',


	// Reportes
	reporteSalud: 'reporte:salud',
	reporteSaludVisitas: 'reporte:salud-visitas',
	reporteSaludInsumos: 'reporte:salud-insumos',
	reporteContabilidad: 'reporte:contabilidad',
	reporteContabilidadCuentas: 'reporte:contabilidad-cuentas',
	reporteContabilidadTransacciones: 'reporte:contabilidad-transacciones',
	reporteContabilidadCheques: 'reporte:contabilidad-cheques',
	reporteContabilidadEntradaDiario: 'reporte:contabilidad-entrada-diario',
	reporteContratos: 'reporte:contratos',
	reporteIngreso: 'reporte:ingreso',
	reporteFacturaReporteFacturas: 'reporte:reporte-facturas',
	reporteFacturaResumenFacturas: 'reporte:resumen-facturas',
	reporteFacturaDetalleImpuesto: 'reporte:detalle-de-impuesto',
	reporteFacturaCuadreCaja: 'reporte:cuadre-de-caja',
	reporteFacturaCuadreCajaResumido: 'reporte:cuadre-de-caja-resumido',
	reporteFacturaListaCarga: 'reporte:lista-de-carga',
	reporteFacturaBalance: 'reporte:balance',
	reporteFacturaBalanceDetalle: 'reporte:balance-detalle',
	reporteFacturaRutaDistribucion: 'reporte:ruta-de-distribución',
	reporteFacturaPlanificacionTareas: 'reporte:planificación-de-tareas',
	reporteFacturaCuadreCajaVentas: 'reporte:cuadre-de-caja-de-ventas',
	reporteFacturaRecurentes: 'reporte:facturas-recurrentes',
	reporteCotizaciones: 'reporte:cotizaciones',
	reporteOrdenesCompraDetalles: 'reporte:ordenes-compra-detalles',
	reporteOrdenesCompraResumen: 'reporte:ordenes-compra-resumen',
	reporteOrdenesCompraListaEntrega: 'reporte:ordenes-compra-lista-entrega',
	reporteOrdenesCuadreCaja: 'reporte:ordenes-cuadre-caja',
	reporteOrdenesCuadreCajaVenta: 'reporte:ordenes-cuadre-caja-venta',
	reporteDespachoFacturasListaCarga: 'reporte:despacho-facturas-lista-carga',
	reporteDespachoFacturasOrdenCarga: 'reporte:despacho-facturas-orden-carga',
	reporteDespachoFacturas: 'reporte:despacho-facturas',
	reporteConsultas: 'reporte:consultas',
	reporteCuentaPorCobrarDetalles: 'reporte:cuentas-por-cobrar-detalles',
	reporteCuentaPorCobrarEstadoCuenta: 'reporte:cuentas-por-cobrar-estado-cuenta',
	reporteCuentaPorCobrarResumen: 'reporte:cuentas-por-cobrar-resumen',
	reporteCuentaPorPagarDetalles: 'reporte:cuentas-por-pagar-detalles',
	reporteCuentaPorPagarEstadoCuenta: 'reporte:cuentas-por-pagar-estado-cuenta',
	reporteCuentaPorPagarResumen: 'reporte:cuentas-por-pagar-resumen',
	reporteRecibos: 'reporte:recibos',
	reporteNotaCredito: 'reporte:notas-credito',
	reporteNotaCreditoDetalleImpuesto: 'reporte:notas-credito-detalle-impuesto',

	reporteNotaDebito: 'reporte:notas-debito',
	reporteNotaDebitoDetalleImpuesto: 'reporte:notas-debito-detalle-impuesto',

	reporteOperaciones: 'reporte:operaciones',
	reporteOperacionesGrupos: 'reporte:operaciones-grupos',
	reporteOperacionesPrestamos: 'reporte:operaciones-prestamos',

	reporteEmpleados: 'reporte:empleados',
	reporteEmpleadosListado: 'reporte:empleados-listado',
	reporteEmpleadosDetalle: 'reporte:empleados-detalle',
	reporteEmpleadosCompararNomina: 'reporte:empleados-comparar-nomina',
	reporteEmpleadosCumpleanos: 'reporte:empleados-cumpleaños',
	reporteEmpleadosSalarioNavidad: 'reporte:empleados-salario-navidad',
	reporteEmpleadosSalarioNavidadDetalle: 'reporte:empleados-salario-navidad-detalle',
	reporteEmpleadosSalarioNavidadSobre: 'reporte:empleados-salario-navidad-sobre',
	reporteEmpleadosSalarioNavidadDesgloses: 'reporte:empleados-salario-navidad-desgloses',
	reporteEmpleadosSalarioNavidadVolantes: 'reporte:empleados-salario-navidad-volantes',
	reporteEmpleadosAperturaCuentaBR: 'reporte:empleados-apertura-cuenta-br',
	reporteEmpleadosVacacionesPendientes: 'reporte:empleados-vacaciones-pendientes',
	reporteAusencias: 'reporte:ausencias',
	reporteAusenciasGeneral: 'reporte:ausencias-general',
	reporteAusenciasVacaciones: 'reporte:ausencias-vacaciones',
	reporteDescuentos: 'reporte:descuentos',
	reporteIncentivos: 'reporte:incentivos',
	reporteSolicitudes: 'reporte:solicitudes',
	reporteReclamaciones: 'reporte:reclamaciones',
	reporteVehiculos: 'reporte:vehiculos',
	reporteVehiculosListado: 'reporte:vehiculos-listado',
	reporteVehiculosLDetalle: 'reporte:vehiculos-detalle',
	reporteServicios: 'reporte:servicios',
	reporteZonas: 'reporte:zonas',
	reporteInventario: 'reporte:inventario',
	reporteInventarioProductosRealizarInventario: 'reporte:inventario-productos-realizar-inventario',
	reporteInventarioProductosInventario: 'reporte:inventario-productos-inventario',
	reporteInventarioProductosReordern: 'reporte:inventario-productos-reorden',
	reporteInventarioProductosBalance: 'reporte:inventario-productos-balance',
	reporteInventarioProductosOperaciones: 'reporte:inventario-productos-operaciones',
	reporteInventarioProductosInventarioCentas: 'reporte:inventario-productos-inventario-centas',
	reporteInventarioProductosPorSuplidor: 'reporte:inventario-productos-por-suplidor',
	reporteInventarioActivoFijos: 'reporte:inventario-activo-fijos',
	reporteInventarioActivoFijosReorden: 'reporte:inventario-activo-fijos-reorden',
	reporteInventarioCompras: 'reporte:inventario-compras',
	reporteInventarioComprasCuadre: 'reporte:inventario-compras-cuadre',
	reporteInventarioComprasDetalleImpuesto: 'reporte:inventario-compras-detalle-impuesto',
	reporteInventarioDespachoInterno: 'reporte:inventario-despacho-interno',
};
